<template>
    <div class="relative text-white h-fit py-4 md:py-24 px-4 md:px-10 bg-teal-900 overflow-hidden">
            <div class="mt-4">
                <h3 class="absolute text-sm md:text-lg top-2 left-4 md:top-10 md:left-10 font-semibold uppercase text-gray-300 font-sans">event</h3>
                <div class="flex flex-row justify-center">
                    <div class="pl-4">
                        <p data-aos="fade-right" data-aos-duration="1000" class="float-right text-2xl sm:text-4xl font-semibold md:text-5xl mb-0 text-gray-100"><i>Recent</i></p> 
                        <p data-aos="fade-right" data-aos-duration="1000" class="pr-1 md:pr-3 text-2xl sm:text-4xl font-semibold md:text-5xl mb-0 text-gray-100"><i>Upcoming</i></p>
                    </div>
                    <h3 data-aos="fade-left" data-aos-duration="1000" class="text-6xl md:text-[150px] align-middle mt-1 text-gray-100"><i>Events</i></h3>
                </div>
                <p data-aos="fade-in" data-aos-duration="2000" class="pb-3 md:pr-4 font-medium uppercase text-center text-sm md:text-xl text-gray-200 font-sans">Các sự kiện gần đây và trong tương lai</p>
            </div>
            <div class="lg:px-12">
                <div v-for="(item, index) in eventData" :key="index" class="d-flex flex-col md:flex-row gap-2 md:gap-4 my-4">
                    <div :class="index%2==1 ? 'md:order-2' : ''" class="md:w-2/3">
                        <img v-if="index == 0"
                            src="@/assets/img/fpt.jpg"  v-viewer
                            class="shadow-md shadow-black w-full h-60 md:h-72 lg:h-80 object-center object-cover rounded-xl"
                        >
                        <img v-if="index == 1"
                            src="@/assets/img/thuydien.jpg"  v-viewer
                            class="shadow-md shadow-black w-full h-60 md:h-72 lg:h-80 object-center object-cover rounded-xl"
                        >
                        <img v-if="index == 2"
                            src="@/assets/img/thethao.jpg" v-viewer
                            class="shadow-md shadow-black w-full h-60 md:h-72 lg:h-80 object-center object-cover rounded-xl"
                        >
                    </div>
                    <div :class="index%2==1 ? 'md:order-1' : ''" class="shadow-md shadow-black w-full h-fit md:h-72 lg:h-80 md:w-1/2 lg:w-1/3 bg-white/30 rounded-xl px-6 py-4 text-white">
                        <h3 class="text-xl md:text-2xl font-semibold">{{ item.title }}</h3>
                        <p class="text-lg md:text-xl font-light text-justify">{{ item.description }}</p>
                    </div>
                </div>
            </div>
        </div>
</template>

<script>
export default {
    props: {
        eventData: Array
    },
}
</script>